import React from 'react';
import { Checkbox } from 'semantic-ui-react';

interface PropTypes {
    allYesChecked: boolean;
    allNoChecked: boolean;
    onAllYesCheck: () => void;
    onAllNoCheck: () => void;
}

export const InfoFoundSelectAll = (props: PropTypes) => {
  return (
    <>
      <Checkbox
        label="All yes"
        checked={props.allYesChecked}
        onChange={(e, { checked }) => {
          if (checked) {
            props.onAllYesCheck();
          }
        }}
      />
      <Checkbox
        style={{ marginLeft: 18 }}
        label="All no"
        checked={props.allNoChecked}
        onChange={(e, { checked }) => {
          if (checked) {
            props.onAllNoCheck();
          }
        }}
      />
    </>
  );
};
